<template>
    <div class="px-2">
        <div class="dataUploadTitle">Cargar datos Inseminación</div>
        <div>
            <validation-observer ref="registerForm">
                <b-form class="auth-register-form mt-2" @submit.prevent="validationForm">
                    <b-form-group class="datePicker">
                        <h5 class="font-weight-bold ">
                            Fecha
                        </h5>
                        <flat-pickr v-model="reproductive.date" class="form-control" />
                    </b-form-group>
                    <b-form-group label="Seleccionar Vaca(Hembras)" label-for="selFemale"  class="selFemale" >

                        <v-select  id="selFemale" v-model="animal_picker" :options="animalsOptions" :values="animalsOptions.value" label="text"  />
                    </b-form-group>
                    <b-form-group label="Identificación de la pajilla" label-for="condition"  class="condition" >

                        <b-form-input  v-model="reproductive.insemination"  />
                    </b-form-group>
                </b-form>
            </validation-observer>
            <div class="additive">
                <b-form-group  label="Observaciones" label-for="Exam">
                    <validation-provider #default="{ errors }" name="Exam" vid="Exam" rules="required|Exam">
                        <b-form-textarea class="ml-1" id="textarea" v-model="reproductive.details"  rows="5"
                            max-rows="6"></b-form-textarea>

                    </validation-provider>
                </b-form-group>
            <b-button
                type="submit" v-on:click="insertReproductive"
                class="bg-primary dataButton mt-3 d-flex align-items-center justify-content-center ml-3"   
            
              >
               <div class="ml-5"> Incluir Evento </div> <div class="pl-3" style="color:#D7B92C"> <feather-icon icon="PlusIcon"  size="18" /></div>
              </b-button>
        </div></div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormGroup, BFormInput, BForm, BImg, BButton, BFormTextarea } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
let self= this;

export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormTextarea,
    },
    data() {
        return {
            date: null,
            animal_picker: null,
            animalsOptions:[],
            reproductive:{
                status:1,
                date:null,
                condition_id:1,
                type:8,
                animal_id:0,
                days:0,
                male_id:0,
                details:'',
                insemination:''
            }
        }
    },
    methods:{
        async fetchAnimals(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.animalsOptions = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
            })
        },

        insertReproductive(){
            this.reproductive.animal_id=this.animal_picker.value;
            this.reproductive.male_id=this.animal_picker.value;
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            console.log(this.reproductive);
            this.$http.post("add/reproductive_records", this.reproductive, config).then(() => {
                this.reproductive={
                    status:1,
                    date:null,
                    condition_id:1,
                    type:8,
                    animal_id:0,
                    days:0,
                    male_id:0,
                    details:'',
                    insemination:''
                }
            
                this.$swal({
                    title: 'Registro reproductivo',
                    text: 'Se insertó registro de inseminación de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    self.$router.replace({name:'basic-farm'});
                });
            }).catch(error => {
                console.log(error)
            });
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
    }
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    position: absolute;
    top: 7%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.datePicker {
    position: absolute;
    top: 15%;
    width: 90%;
    background: #FFFFFF;
    border-radius: 5px;
}

.selFemale{
    position: absolute;
    top: 27%;
    width:90%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B; 
}

.condition {
     position: absolute;
    top: 37%;
    width:90%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B; 
}

.additive {
    position: absolute;
    top: 50%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>